import { ChangeDetectorRef, Component, Input, Optional, Self } from "@angular/core";
import { UntypedFormArray, NgControl } from "@angular/forms";
import { ControlComponent, Option } from "@recore-solutions/nstar-lib";

@Component({
	selector: "app-multi-checkbox-control",
	templateUrl: "./multi-checkbox.component.html",
	styleUrls: ["./multi-checkbox.component.scss"],
})
export class MultiCheckboxComponent extends ControlComponent {
	@Input() showSelectAll = true;
	@Input() selectAllLabel = "All";
	@Input() allowNone = true;
	@Input() options: Option[];
	@Input() fieldControl: UntypedFormArray;
	// @Output() checkboxesChange: EventEmitter<Checkbox[]> = new EventEmitter<Checkbox[]>();

	get optionsForDisplay(): Option[] {
		return this.options
			? this.options.sort((a, b) => (a.sortOrder || 9999) - (b.sortOrder || 9999))
			: [];
	}

	get allSelected(): boolean {
		const values = this.fieldControlValue;
		return !!this.options && this.options.every((o) => values.indexOf(o.value) > -1);
	}

	get noneSelected(): boolean {
		return !this.fieldControl.value || this.fieldControl.value.length < 1;
	}

	get canUncheck(): boolean {
		return this.allowNone || this.fieldControlValue.length > 1;
	}

	get fieldControlValue(): any[] {
		return this.fieldControl.value || [];
	}
	set fieldControlValue(value: any[]) {
		this.fieldControl.patchValue(value);
	}

	selectAllOption: Option = {
		key: this.selectAllLabel,
		value: null,
		sortOrder: 0,
	};

	constructor(
		@Self() @Optional() public control: NgControl,
		protected changeDetectorRef: ChangeDetectorRef
	) {
		super(control, changeDetectorRef);
	}

	onCheckboxChange(option: Option): void {
		if (this.controlHasOption(option)) {
			this.unselectOption(option);
		} else {
			this.selectOption(option);
		}
	}

	selectOption(option: Option): void {
		this.toggleOption(option, true);
	}

	unselectOption(option: Option): void {
		this.toggleOption(option, false);
	}

	toggleOption(option: Option, toggleValue: boolean): void {
		const index = this.indexOfOption(option);
		const newValue = [...this.fieldControlValue];
		newValue[index] = toggleValue;
		this.fieldControl.setValue(newValue);
	}

	optionIsChecked(option: Option): boolean {
		return !!option.value
			? this.controlHasValue(option.value)
			: this.fieldControlValue.length === this.options.length;
	}

	controlHasOption(option: Option): boolean {
		return this.controlHasValue(option.key);
	}

	controlHasValue(value: any): boolean {
		return !!this.fieldControlValue[this.indexOfValue(value)];
	}

	indexOfOption(option: Option): number {
		return this.indexOfValue(option.key);
	}

	indexOfValue(value: any): number {
		return this.options.findIndex((o) => o.key === value);
	}
}
